import { initI18n } from '@betstarters/i18n'

// App-specific translations
import en from './locales/en.json'
import it from './locales/it.json'

export default initI18n({
  appResources: {
    en: { translation: en },
    it: { translation: it },
  },
})
